import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useStore } from '@/store/index'
import { AppActionTypes } from '@/store/modules/app/action-types'
import router from '@/router'

const store = useStore()

export class Interceptors {
    public instance: any

    constructor () {
        // 创建 axios 实例
        this.instance = axios.create({ timeout: 10000 * 12 })
        // 初始化拦截器
        this.initInterceptors()
    }

    // 为了让 http.ts 中获取初始化好的 axios 实例
    public getInterceptors() {
        return this.instance
    }

    // 初始化拦截器
    public initInterceptors () {
        // 设置 post 请求头
        this.instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
        /**
         * 请求拦截器
         * 每次请求前判断 access_token，存在则在请求头中携带
        */
        this.instance.interceptors.request.use((config:any) => {
            if (config.method !== 'get' || config.params.notShowLoading !== true) {
                store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true)
            }
            const access_token = store.state.user.userInfo.access_token
            if (access_token) {
                config.headers['Access-Token'] = access_token
            }
            return config
        }, (error:any) => {
            console.log(error)
        })

        // 响应拦截器
        this.instance.interceptors.response.use((res:any) => {
            store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)

            if (res.data.code == 401) {
                // 401 表示 token 过期或无效，需要重新登录；跳转至登录页
                ElMessage.error('登录过期，请重新登录')
                // 跳转至登录页
                router.push('/login')
                return Promise.resolve(res)
            }
            if (res.headers.authorization) {
                localStorage.setItem('id_token', res.headers.authorization)
            } else {
                if (res.data && res.data.token) {
                    localStorage.setItem('id_token', res.data.token)
                }
            }

            if (res.status === 200) {
                return Promise.resolve(res)
            } else {
                this.errorHandle(res)
                return Promise.reject(res)
            }
        }, (error:any) => {
            const { res } = error
            if (res) {
                // 请求已发出，但不在 2xx 的范围
                this.errorHandle(res)
                return Promise.reject(res)
            } else {
                /**
                 * 处理断网情况
                 * eg: 请求超时或断网时，更新 state 的 network 状态
                 * network 状态在 app.vue 中控制着一个全局的断网提示组件的显示隐藏
                 * 关于断网组件中的刷新重新获取数据，会在断网组件中说明
                */

                ElMessage.error('网络连接异常，请稍后再试！')
            }
        })
    }

    /**
     * http 握手错误
     * @param res 响应回调，根据不同的响应进行不同的操作
    */
    private errorHandle(res: any) {
        // 状态码
        switch (res.status) {
            case 401:
                ElMessage.error('----> 401')
                break
            case 403:
                ElMessage.error('----> 403')
                break
            case 404:
                ElMessage.error('请求的资源不存在')
                break
            default:
                ElMessage.error('连接错误')
        }
    }
}
